import { STORE_CART_NO_ITEMS_API_MESSAGE } from '../storeCart.constants';

interface IStoreCartApiErrorBody {
  message?: string;
  status?: string;
}

/**
 * QA/v3 returns HTTP error + `{ message: "No cart items found" }` for an empty store cart.
 * Treat that as empty cart UI, not the generic load-failure screen.
 */
export const isStoreCartEmptyApiError = (error: unknown): boolean => {
  if (!error || typeof error !== 'object') {
    return false;
  }

  const { data } = error as { data?: unknown };

  if (typeof data === 'string') {
    return data.toLowerCase().includes(STORE_CART_NO_ITEMS_API_MESSAGE.toLowerCase());
  }

  if (data && typeof data === 'object') {
    const { message } = data as IStoreCartApiErrorBody;
    if (typeof message === 'string') {
      return message.toLowerCase().includes(STORE_CART_NO_ITEMS_API_MESSAGE.toLowerCase());
    }
  }

  return false;
};

/** True when the store-cart query failed for a reason other than an empty cart. */
export const isStoreCartLoadFailure = (isError: boolean, error: unknown): boolean =>
  (isError || Boolean(error)) && !isStoreCartEmptyApiError(error);
